<!--purchase_editable-->
<template>
  <article class="recycle-art">
    <group gutter="0">
       <x-input title="收车实价" :max="11" placeholder="请输入收车实价" v-model="price" :disabled="!purchaseEditable">
        <span slot='right' style="color: #000">元</span>
      </x-input>
    </group>
    <p class="tip">车商在“立新车市”是看不到该收车采购价的。</p>

    <div class="btn-bottom">
      <div class="btn-fix">
        <a class="btn" @click.stop="onSubmit()">保存收车信息</a>
      </div>
    </div>
  </article>
</template>
<script>
import {
  XInput,
  Group
} from '@lx-frontend/cvux'
import util from '../../../common/util'
export default {
  components: {
    XInput,
    Group
  },
  data() {
    return {
      price: '',
      source: '',
      id: 0,
      purchaseEditable: true,
      isClicked: false
    }
  },
  created() {
    this.id = this.$route.params.id
    this.source = this.$route.params.source
    this.initData()
  },
  methods: {
    initData() {
      this.$rest.auction.getStatusDetail(null, `${this.id}/purchase`).then((res) => {
        if (res.code === 0) {
          let price = res.data.purchase.price
          this.purchaseEditable = res.data.purchase_editable
          if (price) {
            this.price = (price / 100).toFixed(2)
          }
        }
      })
    },
    onSubmit () {
      let _this = this
      let price = _this.price
      if (!price) {
        this.showToast('请输入收车实价')
        return false
      } else if (!util.regexpMap.regexp_decimals.test(price)) {
        this.showToast('收车实价必须为正数并且至多2位小数')
        return false
      } else if ((price * 100) > 10000000000) {
        this.showToast('请输入0~100000000的价格')
        return false
      }
      let priceConmit = +(price * 100).toFixed(0)
      if (_this.isClicked) {
        return false
      }
      _this.isClicked = true
      _this.$rest.carInfo.recycleCar({
        price: priceConmit
      }, `${this.id}/purchase`).then((res) => {
        if (res.code === 0) {
          this.$router.push(`/auction/carInfo/edit/${this.id}/${this.source}`)
          this.showToast('提交成功')
        } else {
          this.isClicked = false
          this.showToast(res.message)
        }
      }, (res) => {
        this.isClicked = false
        this.showToast(res.message)
      })
    }
  }
}
</script>

<style rel="stylesheet/less" lang="less">
  @w2: 75rem;
  .recycle-art {
     .tip{
        line-height: 74/@w2;
        padding-left: 30/@w2;
        font-size: 26/@w2;
        color: #ababab;
     }
    }
</style>
